module.exports = __webpack_public_path__ + "static/media/employees-import-excel-example.bff5b93d.png";